// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__CommunicationPreferencePopup__commPrefPopupText{font-size:12px;font-weight:700}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/ml-capability-policychange-common-react/pages/ProfileDetails/CommunicationPreferencePopup.module.scss"],"names":[],"mappings":"AAEA,sDACI,cAAA,CACA,eAAA","sourcesContent":["@import \"~@jutro/theme/assets/sass/helpers\";\n\n.commPrefPopupText {\n    font-size: 12px;\n    font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commPrefPopupText": "app__CommunicationPreferencePopup__commPrefPopupText"
};
export default ___CSS_LOADER_EXPORT___;
